import { store } from "@/store/survey"

const surveyMixin = {
  methods: {
    async getNextItem(itemArray, currentNum){
      let nextItem = await itemArray.find(x => x.orderNum === currentNum + 1 || x.orderNum === currentNum + 'a');
      // if enableWhen is present and the answer of enableWhen matches the store's status, return next item
      console.log(`nextItem: ${JSON.stringify(nextItem)}`)
      if (nextItem.enableWhen && nextItem.enableWhen[0] && store.state.status === nextItem.enableWhen[0].answer) {
          return nextItem
      // if enableWhen is not present, return next item
      } else if (!nextItem.enableWhen || nextItem.enableWhen.length == 0) {
        return nextItem
      // else run getNextItem again and add a 1 to order number to progress to next item for assessment
      }
      else return this.getNextItem(itemArray, currentNum + 1)
    },
    async getSection(surveyId, lang, sectionId) {
      if(Object.keys(store.state.survey).length === 0){ // if the stored survey object is empty...
        console.log(`Store empty, getting ${surveyId} survey in language - ${lang}`)
        this.survey = await store.getSurveyAction(surveyId, lang)
      }
      console.log(`getting section - ${Object.values(store.state.survey)}`)
      // If the argument is supplied as an integer, convert to string
      sectionId = Number.isInteger(sectionId) ? sectionId.toString() : sectionId;
      return store.state.survey.items.find(x => x.identifier === sectionId)  
    },
    async goToNextPage(orderNum){
      console.log('going to next section')
      const nextItem = await this.getNextItem(store.state.survey.items, orderNum)
      console.log(nextItem.identifier)
      console.log('calling router method')
      this.$router.push({ name: nextItem.type, params: { surveyId: store.state.survey.name, lang: store.state.survey.languageCode, itemId: nextItem.identifier }})
    },
    async handleActionButton(action){
      if (action[0].action.type === 'pageLink') {
        // goToNextPage() from surveyMixin
        if (action[0].action.target === 'next' && this.instruction) this.goToNextPage(this.instruction.orderNum);
      } else if (action[0].action.type === 'submit' && this.questionSet) {
        const validation = await this.validateSet()
        console.log(`survey valid?: ${validation}`)
        if (validation === true) this.goToNextPage(this.questionSet.orderNum);
      } else if (action[0].action.type === 'continue') {
        const nextLinkId = await this.getNextQuestionLinkId(this.questionSet, action[0].orderNum);
        await this.goToQuestion(nextLinkId);
      }
    },
    async populatePageData(pageType, routeParams) {
      console.log('getting page data')
      this[pageType] = await this.getSection(routeParams.surveyId, routeParams.lang, routeParams.itemId)
    },
    submitAnswers() {
      console.log(store.submitSurvey)
    }
  },
}

export default surveyMixin